/**
 * QGMLWY (Carpalx partial-optimization layout, mkweb.bcgsc.ca/carpalx): maps a physical code to
 * the character that key emits. A Latin letter rearrangement over the US ANSI punctuation block -
 * every digit and symbol key keeps its US QWERTY character, so no key is virtual-key bound and no
 * serialization-token table is needed (the char path reproduces every token). Letters uppercase by
 * table convention. Differs from QGMLWB only in the right-hand letter block (Y/U/O and V/B rows).
 */
export const QGMLWY_CODE_TO_CHAR: Record<string, string> = {
  Backquote: "`",
  Digit1: "1",
  Digit2: "2",
  Digit3: "3",
  Digit4: "4",
  Digit5: "5",
  Digit6: "6",
  Digit7: "7",
  Digit8: "8",
  Digit9: "9",
  Digit0: "0",
  Minus: "-",
  Equal: "=",
  KeyQ: "Q",
  KeyW: "G",
  KeyE: "M",
  KeyR: "L",
  KeyT: "W",
  KeyY: "Y",
  KeyU: "F",
  KeyI: "U",
  KeyO: "B",
  KeyP: ";",
  BracketLeft: "[",
  BracketRight: "]",
  Backslash: "\\",
  KeyA: "D",
  KeyS: "S",
  KeyD: "T",
  KeyF: "N",
  KeyG: "R",
  KeyH: "I",
  KeyJ: "A",
  KeyK: "E",
  KeyL: "O",
  Semicolon: "H",
  Quote: "'",
  KeyZ: "Z",
  KeyX: "X",
  KeyC: "C",
  KeyV: "V",
  KeyB: "J",
  KeyN: "K",
  KeyM: "P",
  Comma: ",",
  Period: ".",
  Slash: "/",
};
